import { render, staticRenderFns } from "./NewItemAlert.vue?vue&type=template&id=12a59c14&"
import script from "./NewItemAlert.vue?vue&type=script&lang=js&"
export * from "./NewItemAlert.vue?vue&type=script&lang=js&"
import style0 from "./NewItemAlert.vue?vue&type=style&index=0&id=12a59c14&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports